import {
  ApplicationStatus,
  ApplicationStatusWithSubStatus,
} from '@/queries/family_applications/requests'
import Badge, { ColorType } from './Badge'

interface Props {
  status: ApplicationStatus
  subStatus: ApplicationStatusWithSubStatus | null
}

function StudentStatusBadge(props: Props) {
  const { status, subStatus } = props

  let usedStatus: ApplicationStatusWithSubStatus = status
  if (status === 'Eligible' && subStatus) {
    usedStatus = subStatus
  }
  if (status === 'Ineligible' && subStatus) {
    usedStatus = subStatus
  }

  function getBadgeName() {
    return usedStatus
  }

  function getColor(status: ApplicationStatusWithSubStatus): ColorType {
    let color: ColorType
    switch (status) {
      case 'Invited':
      case 'V1 Invited':
      case 'ClassWallet Renewal':
      case 'SoftPoint Renewal':
        color = 'Informative'
        break
      case 'Pending':
      case 'In Progress':
      case 'Wait Listed':
        color = 'Notice'
        break
      case 'Complete':
      case 'Awarded':
      case 'Funded':
      case 'Selected':
      case 'Eligible':
        color = 'Positive'
        break
      case 'Ineligible':
      case 'Age Phase Out':
      case 'Withdrawn':
        color = 'Negative'
        break
      default:
        color = 'Neutral'
    }

    return color
  }

  return <Badge semanticColor={getColor(status)}>{getBadgeName()}</Badge>
}

export default StudentStatusBadge
